import { render, staticRenderFns } from "./scrollable-panel.vue?vue&type=template&id=d62bdf52"
import script from "./scrollable-panel.vue?vue&type=script&lang=js"
export * from "./scrollable-panel.vue?vue&type=script&lang=js"
import style0 from "./scrollable-panel.vue?vue&type=style&index=0&id=d62bdf52&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d62bdf52')) {
      api.createRecord('d62bdf52', component.options)
    } else {
      api.reload('d62bdf52', component.options)
    }
    module.hot.accept("./scrollable-panel.vue?vue&type=template&id=d62bdf52", function () {
      api.rerender('d62bdf52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/scrollable-panel/scrollable-panel.vue"
export default component.exports